<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (tap)="cancelOffhire()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>{{title}}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content #content>
    <datepicker [document]="documentTemp"></datepicker>
    <customer-return [document]="documentTemp" (customerChange)="listenCustomer($event)"
                     (documentChange)="listenDocument($event)"></customer-return>
    <site  *ngIf="documentTemp.customer.name"  [document]="documentTemp"></site>
    <contactdetails  [document]="documentTemp"></contactdetails>
    <items-return [document]="documentTemp"></items-return>
    <items *ngIf="documentTemp.documentType === docTypes.BREAKDOWN_COLLECTION" [replacementItem]="true"  [document]="documentTemp"></items>
    <picturestaken  *ngIf="documentTemp.customer.name"  [document]="documentTemp"></picturestaken>
    <sign-now-or-later  *ngIf="documentTemp.customer.name"  [document]="documentTemp"></sign-now-or-later>
    <app-signature *ngIf="documentTemp.customer.name && !documentTemp.signLater" [document]="documentTemp"></app-signature>
    <select-queue-operator *ngIf="documentTemp.signLater" [document]="documentTemp"></select-queue-operator>
    <comments *ngIf="documentTemp.customer.name" [document]="documentTemp"></comments>

    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button (tap)="saveOffhire()" color="success">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>


